var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Hand, Select, Snap",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14021",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11596",
    d: "M14.414 13.654l2.475-2.475a1.5 1.5 0 000-2.121h0a1.5 1.5 0 00-2.121 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11597",
    d: "M16.182 11.886a1.5 1.5 0 012.121 0h0a1.5 1.5 0 010 2.121l-2.475 2.475"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11598",
    d: "M12.293 11.533l6.01-6.01a1.5 1.5 0 000-2.121h0a1.5 1.5 0 00-2.121 0l-7.425 7.425V8.162a1.579 1.579 0 00-1.579-1.579h0a1.525 1.525 0 00-1.495 1.225L4.56 13.43a7.163 7.163 0 001.96 6.47h0a7.165 7.165 0 0010.133 0l2-2 1.061-1.061a1.5 1.5 0 000-2.121h0a1.5 1.5 0 00-2.121 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11599",
    d: "M11.79 2.76l-1.08 1.08"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11600",
    d: "M2.71 2.76l1 1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11601",
    d: "M7.25 2v1.41"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11602",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgEasy;


//////////////////
// WEBPACK FOOTER
// ./src/icons/easy.svg
// module id = 318
// module chunks = 13